import { getValue } from "@clockwise/client-commons/src/util/errorable.util";
import {
  BulkInviteEventGQL,
  BulkInviteEventMap,
  InviteSearchPerson,
  PendingOrgInivteEdgeFromGQL,
} from "../types";

export const getPendingInviteMap = (pendingInvites: PendingOrgInivteEdgeFromGQL[]) => {
  let pendingInviteMap: Record<string, boolean> = {};

  pendingInvites.forEach((edge: any) => {
    pendingInviteMap[edge.node.targetCalendarId] = true;
  });

  return pendingInviteMap;
};

export const findEventsThatRecurWithMultipleAttendees = (events: BulkInviteEventGQL[]) => {
  const eventsThatHaveIntervalsAndMultipleAttendees: BulkInviteEventGQL[] = events.reduce(
    (filteredEvents: BulkInviteEventGQL[], event: BulkInviteEventGQL) => {
      if (event) {
        const attendees = getValue(event.attendeePeople);
        if (
          !!event.recurrenceRules &&
          attendees &&
          attendees?.list?.length > 2 &&
          attendees?.list?.length < 11 // 11 including current user, in reality we want 10 others to invite max
        ) {
          // check to ensure the event title hasn't already been added
          // (for daily/ less than weekly repeating events)
          if (!filteredEvents.some((existingEvent) => existingEvent.title === event.title)) {
            filteredEvents.push(event);
          }
        }
      }
      return filteredEvents;
    },
    [],
  );

  return eventsThatHaveIntervalsAndMultipleAttendees;
};

export const getSuggestedBulkInviteEvents = (
  events: BulkInviteEventGQL[],
  pendingInvites: PendingOrgInivteEdgeFromGQL[],
): BulkInviteEventMap => {
  if (!events) return {};
  const eventsThatHaveIntervalsAndMultipleAttendees: BulkInviteEventGQL[] = findEventsThatRecurWithMultipleAttendees(
    events,
  );

  const pendingPersonsMap = getPendingInviteMap(pendingInvites);
  let eventsMap: BulkInviteEventMap = {};

  eventsThatHaveIntervalsAndMultipleAttendees.forEach((event) => {
    const nonUserAttendees: Set<InviteSearchPerson> = new Set();

    const attendees = getValue(event.attendeePeople);
    if (attendees && attendees?.list?.length && attendees.list.length > 1) {
      attendees.list.forEach((attendee) => {
        const { primaryEmail, profile, isUser, isYou } = attendee;
        const isPending = !!pendingPersonsMap[primaryEmail];

        if (!isYou && !isUser && !isPending) {
          const attendeeInviteSearchPerson: InviteSearchPerson = {
            primaryCalendarId: primaryEmail,
            profile: {
              givenName: !!profile && !!profile?.givenName ? profile.givenName : primaryEmail, // if no user profile or givenName, show primaryEmail
              familyName: !!profile && !!profile?.familyName ? profile.familyName : "",
              externalImageUrl:
                !!profile && !!profile?.externalImageUrl ? profile.externalImageUrl : "",
            },
            isUser: isUser,
          };
          nonUserAttendees.add(attendeeInviteSearchPerson);
        }
      });
    }

    // Add to event map if there are still less than 3, and the event has more than 1 non user attendee
    if (event.title && Object.keys(eventsMap).length < 3 && nonUserAttendees.size > 1) {
      eventsMap[event.eventKey.id] = {
        title: event.title,
        attendees: Array.from(nonUserAttendees),
      };
    }
  });

  return eventsMap;
};
